import React, { useState } from "react";
import Steps from "../Steps/Steps";

const Step3=(props)=>{
    return(
        <>
        <Steps step={2} />
        </>
    )
}
export default Step3;